import { z } from 'zod';
/**
 * Ce que le front apprend du serveur pour son suivi des erreurs (ADR 0013).
 *
 * Lu au démarrage et non injecté à la construction : l'image du front est la
 * même de la recette à la production, seul le `.env` du serveur change.
 * `dsn` nul = suivi éteint, rien ne part.
 */
export const schemaConfigurationSuiviErreurs = z.object({
    dsn: z.string().nullable(),
    environnement: z.string(),
    version: z.string(),
});
/**
 * Le relais par lequel passent les erreurs du navigateur : même origine que
 * l'application, et l'API nettoie une seconde fois avant de transmettre.
 */
export const CHEMIN_RELAIS_SUIVI_ERREURS = '/api/v1/suivi-erreurs/envoi';
//# sourceMappingURL=configuration.js.map